import PageContext from "global_state/context/PageContext"
import {  useCallback, useContext, useEffect, useRef, useState } from "react"
import SCSS from 'assets/scss/PopUp.module.scss'
import FormSCSS from 'assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'
import { BiChevronDown, BiChevronUp } from "react-icons/bi"
import { getPaymentGetwayService } from "services/GetPaymentGetwayService"
import { PaymentsType } from "types/PaymentsI"
import Loader from "components/Loader"
import { getUser } from "services/user_services/GetUser"
import UserContext from "global_state/context/UserContext"

import content from 'languages/BuyCreditPopUp.json'

function BuyCreditPopUp() {
    let {page, dispatchPage} = useContext(PageContext)
    let {user,dispatchUser} = useContext(UserContext)
    let lang = page.settings.language

    const [custom_credit_value, setCustomCreditValue] = useState<number>(200)
    const [payment_getway_response, setPaymetnGetway] = useState<any>()
    
    const inputRef = useRef<any>(null);

    const [loading, setLoading] = useState(false)

    const handleESC = useCallback((event) => {
        if (event.key === 'Escape') {
            dispatchPage({
                type: "set_popup",
                payload: {
                    popup: null,
                }
            })
        }
    }, [])

    useEffect(() => {
        document.addEventListener("keydown", handleESC, false);
        
        return () => {
            document.removeEventListener("keydown", handleESC, false);
        };

    })

    useEffect(() => {
        inputRef.current.focus();
        inputRef.current.scrollIntoView({behavior: "smooth"})    
    }, [])
    

    useEffect(() => {
        // console.log('use Effect: payment_getway_response'.toUpperCase());
        // console.log(payment_getway_response);
        
        if (!payment_getway_response) {
            return 
        }

        if (payment_getway_response === 'error') {
            setLoading(false)

            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "general_error"
                    }
                }
            }) 
            return 
        }
        if (payment_getway_response === 'no_url') {
            setLoading(false)

            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "general_error"
                    }
                }
            }) 
            return     
        }

        if (typeof payment_getway_response == 'object' && 'gw_url' in payment_getway_response) {
            // console.log('payment_getway_response'.toUpperCase());
            // console.log(payment_getway_response.gw_url);
            
            window._gopay.checkout({gatewayUrl: payment_getway_response.gw_url, inline: true}, async (checkoutResult) => {
                
                // console.log("GOPAY CALLBACK");
                // console.log(checkoutResult);

                if (checkoutResult.state == 'PAID') {
                    // TODO: load user
                    const updateUser = async () => {
                        let user = await getUser()
                        dispatchUser({type: "update_user_credits", payload: user})
                    }
                    updateUser()
                    dispatchPage({
                        type: "add_notification",
                        payload: {
                            notification: {
                                type: "success",
                                message: "credit_added_success"
                            }
                        }
                    }) 
                }              
                if (checkoutResult.state != 'PAID') {
                    dispatchPage({
                        type: "add_notification",
                        payload: {
                            notification: {
                                type: "warning",
                                message: "credit_not_added"
                            }
                        }
                    }) 
                }  
                dispatchPage({
                    type: "set_popup",
                    payload: {
                        popup: null,
                    }
                })

            })

        }
        
    }, [payment_getway_response])

    const closePopUp = (e) => {
        dispatchPage({
            type: "set_popup",
            payload: {
                popup: null,
            }
        })
    }
    const handleCustomCreditValue = () => {


        if (custom_credit_value < 200) {
            setCustomCreditValue(200)
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "warning",
                        message: "credit_value_not_in_interval"
                    }
                }
            }) 
            return 
        }
        if (custom_credit_value > 50000) {
            setCustomCreditValue(50000)
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "warning",
                        message: "credit_value_not_in_interval"
                    }
                }
            }) 
            return 
        }
        

    }
    const handleCredit = (point) => {

        const multiplier = 100
                
        if (!custom_credit_value) {
            setCustomCreditValue(200)
        }

        if (custom_credit_value + point <= 200) {
            setCustomCreditValue(200)
            return 
        }

        setCustomCreditValue(custom_credit_value + (multiplier * point))        
    }
    const handleBuyCredit = async (e) => {
        // console.log("handle Buy Credit".toUpperCase());
        e.preventDefault()

        if (!custom_credit_value || custom_credit_value < 200) {
            setCustomCreditValue(200)
            return 
        }
        setLoading(true)
        setPaymetnGetway(
            await getPaymentGetwayService(
                [{
                    type: 'ITEM', 
                    name: 'Kredit',
                    amount: custom_credit_value,
                    count: 1
                }], 
                custom_credit_value, 
                user.client_id, 
                PaymentsType.credits,
                lang
            )
        )
    }

    const renderLoading = () => {
        if (!loading) {
            return null
        }
        return <Loader />
    }

    const renderContent = () => {
        if (loading) {
            return null
        }

        return (
            <>
                <div className={SCSS.close} ref={inputRef}>
                    <button 
                        type="button"
                        className={[AppSCSS.button, AppSCSS.smaller, AppSCSS.no_shadow, AppSCSS.gray].join(" ")} 
                        onClick={(e) => {closePopUp(e)}}>
                            {content[lang].pop_up_close}
                    </button>
                </div>

                <div className={SCSS.title}>
                    {content[lang].add_credit}
                </div>
                <div className={SCSS.credit_usage}>
                    <div>{content[lang].pop_up_credit_use}</div>
                    <div>
                        <div className={SCSS.credit_usage_li}>{content[lang].pop_up_credit_use_1}</div>
                        <div className={SCSS.credit_usage_li}>{content[lang].pop_up_credit_use_2}</div>
                    </div>
                    
                </div>
                <div className={SCSS.rules}>
                    <a target="_blank" href={content[lang].rules_link}>
                        {content[lang].rules_text}
                    </a>
                </div>

                
                <label className={[FormSCSS.label, SCSS.credits_label].join(" ")}>
                    <input 

                        className={[FormSCSS.input, SCSS.border, SCSS.credits].join(" ")}
                        placeholder={content[lang].input_user_name_placeholde} 
                        onChange={(e) => {
                            setCustomCreditValue(parseInt(e.target.value))
                        }} 
                        onBlur={(e) => {
                            handleCustomCreditValue()
                        }}
                        type="number" name="custom_value" 
                        id="custom_value" value={custom_credit_value} />
                </label>
                <div className={[SCSS.credits_controls].join(" ")}>
                    <button
                        type="button" 
                        onClick={(e) => {handleCredit(-1)}}
                        className={[SCSS.control, SCSS.border].join(" ")}>
                        <BiChevronDown></BiChevronDown>
                    </button>
                    <button 
                        type="button" 
                        onClick={(e) => {handleCredit(1)}}
                        className={[SCSS.control, SCSS.border].join(" ")}>
                        <BiChevronUp></BiChevronUp>
                    </button>
                </div>
                <div className={SCSS.warning}>
                    {content[lang].add_credit_warning}
                </div>
                <div>
                    <button 
                        type="submit"
                        className={[AppSCSS.button, AppSCSS.red, SCSS.buy].join(" ")} 
                        onClick={(e) => {handleBuyCredit(e)} }>
                            {content[lang].pop_up_buy}
                    </button>
                </div>
            </>
        )
    }

    return (

        <div className={SCSS.buy_credit_popup}>

            <form className={FormSCSS.form}>
                {renderLoading()}
                {renderContent()}

            </form>
        

        </div>
    )
}

export default BuyCreditPopUp